import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { Page_settings } from "@/config/page_settings";
import { useNavigate } from "react-router-dom";
import { API_URL, RESULT_CODE } from "@/config/const";

const BillConfirmPage = () => {
  /* **********************************
    * GLOBAL STATE
    * 전역 상태 및 전역 변수
    ********************************** */
  const navigate = useNavigate();
  const context: any = useContext(Page_settings);
  //const [data, setData] = useState(null);

  //const [chewingplusKey, setChewingplusKey] = useState("");
  //const [approvalAmount, setApprovalAmount] = useState("0");

  useEffect(() => {
    
    goChewingplusPaymentPage();

    
  }, []); 

  //츄잉플러스 결제서비스 호출
  const goChewingplusPaymentPage = () => {
    //결제요청 메시지에서 츄잉플러스 요청키 값 가져오기(ex:payKey)
    const params = new URLSearchParams(window.location.search);
    const chewingplusKey = params.get('chewingplusKey'); // "12345678"    
    const approvalAmount = "1004";
    
    context.post(
      `/chewingplus/payTestRequest`,  //츄잉플러스 URL  /platform/payTestRequest
      {
        chewingplusKey: chewingplusKey,
        approvalAmount: approvalAmount,
      },
      (response) => {
        console.log(response);
        //setData(response); // 상태에 JSON 데이터 할당
        goPaymentPage(response);
      }
    );
  };

  //츄잉페이 결제서비스 호출
  const goPaymentPage = (data) => {
    context.post(
      '/api/requestPayment',
      data,
      (response) => {
        if(response.RESULT_CODE === "0000"){
          window.location.href = response.REDIRECT_URL;
        }else{
          //요청실패
          alert(response.RESULT_CODE);
          alert(response.RESULT_MSG);
        }
      }
    );
  };

  
}

export default BillConfirmPage;